import korobochka from "../../Boxy.png";
import React from "react";
import styles from "./Logo.module.css";

const Logo: React.FC = () => {
  return (
    <div className={styles.root}>
      <img
        src={korobochka}
        alt="logo"
        className={styles.logo}
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />
      <h1 className={styles.title}>КОРОБОЧКА</h1>
      <strong className={styles.subtitle}>
        Система учёта домашнего хозяйства
      </strong>
    </div>
  );
};
export default Logo;
